// /opt/isp_erp/frontend/src/components/tickets/PDFButton.jsx

import React, { useState } from 'react';
import { IconButton, Tooltip, CircularProgress, Button } from '@mui/material';
import { PictureAsPdf as PdfIcon } from '@mui/icons-material';
import { ticketsAPI } from '../../api/tickets.api';

const PDFButton = ({ 
  ticketId, 
  ticketNumber, 
  variant = 'icon',
  type = 'instalacion'  // ✅ NUEVO: tipo de ticket
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // ✅ NUEVO: Mapeo de tipos a funciones de API
  const getPDFFunction = () => {
    switch (type) {
      case 'instalacion':
        return ticketsAPI.generateInstallationPDF;
      case 'cambio_equipo':
        return ticketsAPI.generateEquipmentChangePDF;
      case 'retiro':
        return ticketsAPI.generateRetirementPDF;
      case 'incidente':
        return ticketsAPI.generateIncidentPDF;
      default:
        return ticketsAPI.generateInstallationPDF;
    }
  };

  // ✅ NUEVO: Obtener nombre del archivo según tipo
  const getFileName = () => {
    switch (type) {
      case 'instalacion':
        return `instalacion_${ticketNumber}`;
      case 'cambio_equipo':
        return `cambio_equipo_${ticketNumber}`;
      case 'retiro':
        return `retiro_${ticketNumber}`;
      case 'incidente':
        return `incidente_${ticketNumber}`;
      default:
        return `ticket_${ticketNumber}`;
    }
  };

  // ✅ NUEVO: Obtener texto del tooltip
  const getTooltipText = () => {
    switch (type) {
      case 'instalacion':
        return 'Generar PDF de instalación';
      case 'cambio_equipo':
        return 'Generar PDF de cambio de equipo';
      case 'retiro':
        return 'Generar PDF de retiro';
      case 'incidente':
        return 'Generar PDF de incidente';
      default:
        return 'Generar PDF';
    }
  };

  const handleGeneratePDF = async () => {
    setLoading(true);
    setError('');
    
    try {
      const pdfFunction = getPDFFunction();
      const response = await pdfFunction(ticketId);

      // Crear blob y descargar
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${getFileName()}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error generando PDF:', error);
      // ✅ NUEVO: Mensaje de error más descriptivo
      if (error.response?.status === 400) {
        const datosErrorPdf = error.response && error.response.data;
        const textoErrorPdf = (d) => (d && typeof d.detail === 'string' ? d.detail : 'No se pudo generar el PDF');
        if (datosErrorPdf instanceof Blob) {
          // El servidor responde el error como archivo (blob): se lee para mostrar el motivo real
          datosErrorPdf.text().then((txt) => {
            let d = null;
            try { d = JSON.parse(txt); } catch (e) { d = null; }
            alert(`Error: ${textoErrorPdf(d)}`);
          }).catch(() => alert('Error: No se pudo generar el PDF'));
        } else {
          alert(`Error: ${textoErrorPdf(datosErrorPdf)}`);
        }
      } else {
        alert('Error al generar el PDF. Por favor, intente nuevamente.');
      }
      setError(error.response?.data?.detail || 'Error al generar el PDF');
    } finally {
      setLoading(false);
    }
  };

  if (variant === 'icon') {
    return (
      <Tooltip title={getTooltipText()}>
        <IconButton
          size="small"
          onClick={handleGeneratePDF}
          disabled={loading}
          color="primary"
        >
          {loading ? <CircularProgress size={20} /> : <PdfIcon />}
        </IconButton>
      </Tooltip>
    );
  }

  // ✅ NUEVO: Variante Button (para usar en listas)
  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      onClick={handleGeneratePDF}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={16} /> : <PdfIcon />}
    >
      {loading ? 'Generando...' : 'PDF'}
    </Button>
  );
};

export default PDFButton;
